import { Component } from '@angular/core';
import { CalendarDayBaseComponent } from 'projects/shared/lib/components/shared/base/calendar/day/calender-day-base.component';

@Component({
    selector: 'app-calendar-day',
    templateUrl: './calendar-day.component.html',
    standalone: false
})
export class CalendarDayComponent extends CalendarDayBaseComponent { }
